import React from "react";
import { connect } from "react-redux";
import 'bootstrap/dist/css/bootstrap.min.css';
import CommonRouter from "../views/CommonRouter";
import RouteChangeTracker from "../utils/RouteChangeTracker";

class App extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section>
                <RouteChangeTracker />
                <CommonRouter />
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
        config: state.config,
    };
};

export default connect(mapStateToProps)(App);